module.exports = __webpack_public_path__ + "assets/media/lunch.fcd8fb65.mp3";